export const AccessibilityStatementData = [{
'gr':{
  id: 1,
  title: '',
  text:`

<h3>Δήλωση προσβασιμότητας</h3>
Ο Δήμος Χανίων δεσμεύεται να καθιστά τον οικείο ιστότοπο προσβάσιμο, σύμφωνα με την οδηγία (Ευρωπαϊκή Ένωση) 2016/2102 του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου. Η παρούσα δήλωση προσβασιμότητας εφαρμόζεται στον ιστότοπο: <a href="https://www.explorechania.gr" target="_blank" style="color: rgb(10, 85, 114);
text-decoration: underline;">https://www.explorechania.gr </a>

<h3>Κατάσταση συμμόρφωσης</h3>
<div>
α) Ο παρών Ιστότοπος δημιουργήθηκε με χρήση του Responsive Design δίνοντας έτσι την ευελιξία να προβάλλεται βέλτιστα και να είναι πλήρως προσβάσιμος από οποιαδήποτε συσκευή, προσαρμόζοντας το περιεχόμενό του σε οποιουδήποτε μεγέθους οθόνη που προβάλλεται, προσφέροντας έτσι μία καλή εμπειρία πλοήγησης στον/στη χρήστη του.
</div>
<div>
β) Ο Ιστότοπος αυτός συνάδει εν μέρει με τις απαιτήσεις και τις Οδηγίες Προσβασιμότητας Περιεχομένου Ιστού 2.1 Επιπέδου ΑΑ (Web Content Accessibility Guidelines (WCAG) 2.1 Level AΑ), λόγω των μη συμμορφώσεων που αναφέρονται παρακάτω:
</div>
<div>
Οι περιοχές όπου η παρουσίαση της πληροφορίας απαιτεί τη χρήση ημερολογίου, προς το παρόν είναι μη προσβάσιμες για τους τυφλούς χρήστες. Η ανάπτυξη, όμως, εναλλακτικού, προσβάσιμου τρόπου παρουσίασης τους, βρίσκεται σε εξέλιξη και σύντομα θα είναι διαθέσιμη.
</div>
Η αναπαραγωγή των βίντεο δεν είναι προσβάσιμη. Σύντομα όμως το λογισμικό αναπαραγωγής θα αντικατασταθεί από κάποιο προσβάσιμο, με δυνατότητες: αναπαραγωγής, παύσης, διακοπής, προώθησης προς τα εμπρός και πίσω του βίντεο από τον χρήστη. Επιπλέον θα υποστηρίζεται η χρήση υπότιτλων.


<h3>Διαδικασία και ενέργειες ελέγχου</h3>
<div>
Η παρούσα δήλωση καταρτίστηκε στις 20/03/2022.
</div>
<div>
Ο έλεγχος προσβασιμότητας περιλάμβανε πραγματική αξιολόγηση προσβασιμότητας η οποία πραγματοποιήθηκε από το ITE – Ινστιτούτο Πληροφορικής (HCI Lab).
</div>
<div>
Η αξιολόγηση της προσβασιμότητας του ιστοτόπου πραγματοποιήθηκε με χρήση ειδικών εργαλείων αξιολόγησης προσβασιμότητας και με αξιολόγηση από εμπειρογνώμονες.
</div>
<div>
Συγκεκριμένα, περιέλαβε τις εξής ενέργειες:
</div>
<div>
Σάρωση με το εργαλείο Wave Web Accessibility (powered by WebAIM) και Total Validator για αυτόματη επισήμανση και διόρθωση πιθανών προβλημάτων προσβασιμότητας.
Ακουστικό έλεγχο και αναφορά λαθών ή παραλείψεων από εμπειρογνώμονα προσβασιμότητας με τα ακόλουθα λογισμικά ανάγνωσης οθόνης: JAWS, NVDA και τους φυλλομετρητές: Chrome και Edge.
</div>
<div>
Έλεγχο από εμπειρογνώμονα προσβασιμότητας ως προς τα παρακάτω:
</div>
<div>
<ul>
<li>&#x2022; δυνατότητα προσπέλασης του περιεχομένου αποκλειστικά με χρήση πληκτρολογίου και ειδικών διακοπτών (switch buttons).</li>
<li>&#x2022; υποστήριξη μεγέθυνσης γραμματοσειράς έως 300% χωρίς προβλήματα στη δομή των σελίδων.</li>
<li>&#x2022; δυνατότητα παρουσίασης περιεχομένου μετά την απενεργοποίηση των γραφικών και εικόνων (disable all images).</li>
<li>&#x2022; χρήση βοηθητικού συνδέσμου για τη διευκόλυνση προσπέλασης επιλαμβανόμενων στοιχείων του ιστότοπου (π.χ. μετάβαση στο περιεχόμενο).</li>
</ul>

<h3>Υποβολή παρατηρήσεων και στοιχεία επικοινωνίας</h3>
Σύμφωνα με τις προβλέψεις του αρθ.10 ν.4591/2019, κάθε ενδιαφερόμενος έχει δικαίωμα να υποβάλλει παρατηρήσεις ή αίτηση για ενημέρωση ως προς την κατάσταση συμμόρφωσης ή αίτηση για πληροφορίες που ελλείπουν (βλ. παρ.3 αρθ.2 και αρθ.5 ν. 4591/2019). Τα ανωτέρα μπορούν να αποσταλούν στον αρμόδιο φορέα για θέματα προσβασιμότητας ITE – Ινστιτούτο Πληροφορικής (HCI Lab), στην ηλεκτρονική διεύθυνση: e-accessibility@ics.forth.gr.

<h3>Διαδικασία εκτέλεσης</h3>
Σε περίπτωση μη ικανοποιητικής απάντησης στην ενημέρωση ή στα αιτήματα του αρθ.10 «Υποβολή παρατηρήσεων, αιτημάτων για παροχή πληροφοριών και αναφορών» ν.4591/2019, ο ενδιαφερόμενος δικαιούται να αποταθεί σύμφωνα με την πρόβλεψη του αρθ.7 ν.4591/2019 στις αρμόδιες θεσμικές αρχές, όπως με την υποβολή σχετικής αναφοράς στον Συνήγορο του Πολίτη (www.synigoros.gr) χρησιμοποιώντας την ακόλουθη διεύθυνση ηλεκτρονικής αλληλογραφίας: press@synigoros.gr

`
  },
  
'en':{
  id: 2,
  title: 'About us',
  text:`
<div>
  O παρόν δικτυακός τόπος, explorechania.gr, αναπτύχθηκε στο πλαίσιο του έργου «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων».  Χρηματοδοτήθηκε από το ΕΠ «Κρήτη» 2014-2020 (MIS :5030576, ΣΑΕΠ 002/1: 2019ΕΠ00210023) από την Ευρωπαϊκή Ένωση - Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) και από εθνικούς πόρους .
</div>
<div>
  Το έργο αυτό με δικαιούχο τον Δήμο Χανίων, βασίζεται στη διαδημοτική συνεργασία όλων των Δήμων της Περιφερειακή Ενότητας (Π.Ε.) Χανίων και της Εφορείας Αρχαιοτήτων Χανίων.
</div>
<div>
  Στοχεύει στην από κοινού ολοκληρωμένη προβολή και ανάδειξη του πολιτιστικού και τουριστικού αποθέματος των επτά (7) Δήμων της Π.Ε Χανίων (Αποκορώνου, Γαύδου, Καντάνου - Σελίνου, Κισσάμου, Πλατανιά, Σφακίων και Χανίων), μέσα από ένα σύνολο καινοτόμων και συνδυαστικών ψηφιακών δράσεων, που παρέχουν νέες δυνατότητες προβολής του πολιτιστικού και τουριστικού περιεχομένου, στους κατοίκους και επισκέπτες των Χανίων.
  </div>
<div>
  Δείτε περισσότερες πληροφορίες πλαίσιο για το έργο εδώ: «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων»
</div>
 
  `
},
'bg':{
  id: 3,
  title: 'About us', 
  text:`
<div>
  O παρόν δικτυακός τόπος, explorechania.gr, αναπτύχθηκε στο πλαίσιο του έργου «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων».  Χρηματοδοτήθηκε από το ΕΠ «Κρήτη» 2014-2020 (MIS :5030576, ΣΑΕΠ 002/1: 2019ΕΠ00210023) από την Ευρωπαϊκή Ένωση - Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) και από εθνικούς πόρους .
</div>
<div>
  Το έργο αυτό με δικαιούχο τον Δήμο Χανίων, βασίζεται στη διαδημοτική συνεργασία όλων των Δήμων της Περιφερειακή Ενότητας (Π.Ε.) Χανίων και της Εφορείας Αρχαιοτήτων Χανίων.
</div>
<div>
  Στοχεύει στην από κοινού ολοκληρωμένη προβολή και ανάδειξη του πολιτιστικού και τουριστικού αποθέματος των επτά (7) Δήμων της Π.Ε Χανίων (Αποκορώνου, Γαύδου, Καντάνου - Σελίνου, Κισσάμου, Πλατανιά, Σφακίων και Χανίων), μέσα από ένα σύνολο καινοτόμων και συνδυαστικών ψηφιακών δράσεων, που παρέχουν νέες δυνατότητες προβολής του πολιτιστικού και τουριστικού περιεχομένου, στους κατοίκους και επισκέπτες των Χανίων.
  </div>
<div>
  Δείτε περισσότερες πληροφορίες πλαίσιο για το έργο εδώ: «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων»
</div>
  `
}}
]
